import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomeComponents from "./Components/HomeComponents";
import IciciThanks from "./Components/IciciThanks";
import ContentICICI from "./Components/ContentICICI";
// import PopupForm from "./Components/PopupForm";
import ClickHere from "./Components/ClickHere";
import "../node_modules/slick-carousel/slick/slick.css";
import "../node_modules/slick-carousel/slick/slick-theme.css";
function App() {
  return (
    <Router basename={window.location.pathname}>
    
      <Routes>
        <Route path="/" element={<HomeComponents />} />
        <Route path="/IciciThanks" element={<IciciThanks />} />
        <Route path="/ContentICICI" element={<ContentICICI />} />
        <Route path="/ClickHere" element={<ClickHere />} />

      </Routes>
    </Router>
    
  );
}

export default App;
